import angular from 'angular';

import uploadClassicComponent from './upload-classic/upload-classic.component';
import uploadClassicBlock from './upload-classic-block/upload-classic-block.component';
import uploadClassicLinks from './upload-classic-links/upload-classic-links.component';
import contextLinkValidatorDirective from './upload-classic-links/ctx-link-validator.directive';
import uploadErrorsRun from './upload-classic/upload-errors.run';
import kFileUploadDirective from './k-file-upload.directive';

export default angular
	.module('app.upload', [])
	.run(uploadErrorsRun)
	.component('uploadClassic', uploadClassicComponent)
	.component('uploadClassicBlock', uploadClassicBlock)
	.component('uploadClassicLinks', uploadClassicLinks)
	.directive('kFileUpload', kFileUploadDirective)
	.directive('ctxLinkValidator', contextLinkValidatorDirective)
	.name;
